const { toggle } = window.o_util ?? {};
const { get } = toggle ?? {};
export {
  get,
  toggle
};
/*                               */
